import React, { useEffect, useState } from 'react';
import renderIf from 'render-if';
import flagRecord, { type RecordTypes } from './flagRecordHelper';
import styles from './ManuallyFlagged.module.css';
import AhaAnalytics from 'javascripts/analytics';

type ManualRiskFlagProps = {
  recordType: RecordTypes;
  recordId: string;
  manualRiskComment: string;
};

const ManuallyFlagged: React.FC<ManualRiskFlagProps> = ({
  recordType,
  recordId,
  manualRiskComment,
}) => {
  const [comment, setComment] = useState(manualRiskComment);
  const [loading, setLoading] = useState(false);
  const [showComment, setShowComment] = useState(comment !== '');

  const setRiskComment = async manualRiskComment => {
    if (loading) return;
    setLoading(true);

    flagRecord(recordType, recordId, manualRiskComment);
  };

  // Reset the loading state and comment when our props are updated via a reactive update
  useEffect(() => {
    if (loading) {
      setLoading(comment !== manualRiskComment);
    }
    if (!manualRiskComment) {
      setShowComment(false);
    }
    setComment(manualRiskComment);
  }, [manualRiskComment]); // eslint-disable-line react-hooks/exhaustive-deps

  const buttons = (
    <div className={styles.buttonRow}>
      {renderIf(loading)(() => (
        <aha-spinner track />
      ))}
      {renderIf(!showComment)(() => (
        <aha-button
          size='small'
          onClick={() => {
            if (!loading) {
              setShowComment(true);

              AhaAnalytics.track(
                'Feature-7148130073796750739',
                'User adds comment to flag',
                {
                  'Workspace type': window?.currentWorkspaceType,
                  'Record type': recordType,
                }
              );
            }
          }}
          disabled={loading || null}
        >
          Add comment
        </aha-button>
      ))}
    </div>
  );

  return (
    <>
      <i className='fa-regular fa-flag-pennant risk-icon' />
      <div className='risk-row__wrapper'>
        <div className={styles.headerRow}>
          <span>Flagged record</span>
          {buttons}
        </div>
        <div>
          {renderIf(showComment)(() => (
            <div className={styles.commentEntry}>
              <input
                type='text'
                disabled={loading}
                value={comment}
                onChange={e => setComment(e.currentTarget.value)}
                onKeyUp={e => {
                  if (e.key === 'Enter') {
                    setRiskComment(comment ?? '');
                  }
                }}
              />
              {renderIf(comment !== manualRiskComment)(() => (
                <aha-button
                  size='small'
                  kind='primary'
                  class={styles.saveCommentButton}
                  disabled={loading || null}
                  onClick={() => {
                    setRiskComment(comment ?? '');
                  }}
                >
                  Save
                </aha-button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ManuallyFlagged;
